import React from "react";
import { PageLoader as ChrPageLoader } from "@monster/chr-ui";
import { LoctoolMessage } from "@monster/loctool";

export const PageLoader = () => {
    return <ChrPageLoader variant="general" title={<LoctoolMessage id={"components.pageLoader.title"} />} subTitle={""} />;
};
